import React from "react";
import "./styles.css";

/**
 * Texto pequeño en uppercase con tracking amplio.
 * Se usa como "eyebrow" o etiqueta superior antes de un heading principal.
 */
export const EyebrowText = ({ children, className = "" }) => {
  return (
    <span className={`eyebrow-text ${className}`.trim()}>{children}</span>
  );
};
